var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 3.33325V2.66659C4.66667 2.31296 4.80714 1.97382 5.05719 1.72378C5.30724 1.47373 5.64638 1.33325 6 1.33325H10C10.3536 1.33325 10.6928 1.47373 10.9428 1.72378C11.1929 1.97382 11.3333 2.31296 11.3333 2.66659V3.33325H13.3333C13.5101 3.33325 13.6797 3.40349 13.8047 3.52851C13.9298 3.65354 14 3.82311 14 3.99992C14 4.17673 13.9298 4.3463 13.8047 4.47132C13.6797 4.59635 13.5101 4.66659 13.3333 4.66659H12.6667V11.9999C12.6667 12.5304 12.456 13.0391 12.0809 13.4141C11.7058 13.7892 11.1971 13.9999 10.6667 13.9999H5.33333C4.8029 13.9999 4.29419 13.7892 3.91912 13.4141C3.54405 13.0391 3.33333 12.5304 3.33333 11.9999V4.66659H2.66667C2.48986 4.66659 2.32029 4.59635 2.19526 4.47132C2.07024 4.3463 2 4.17673 2 3.99992C2 3.82311 2.07024 3.65354 2.19526 3.52851C2.32029 3.40349 2.48986 3.33325 2.66667 3.33325H4.66667ZM6 2.66659H10V3.33325H6V2.66659ZM4.66667 4.66659H11.3333V11.9999C11.3333 12.1767 11.2631 12.3463 11.1381 12.4713C11.013 12.5963 10.8435 12.6666 10.6667 12.6666H5.33333C5.15652 12.6666 4.98695 12.5963 4.86193 12.4713C4.7369 12.3463 4.66667 12.1767 4.66667 11.9999V4.66659Z",
    fill: "#F57561"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.99976H8.66667V11.3331H10V5.99976ZM7.33333 5.99976H6V11.3331H7.33333V5.99976Z",
    fill: "#F57561"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2abc406c24207b0ff34cf2ad74d5ec38.svg";
export { ForwardRef as ReactComponent };